import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { AvatarWithStatus } from "../../../../components/AvatarWithStatus";
import { Routes } from "../../../../constants/routes";
import { urlReplacer } from "../../../../utils";
import { ISchoolStudentListItemProps } from "../../../school/types";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  name: {
    fontSize: 12,
    color: "#192130",
    marginTop: 14,
    textAlign: "center",
  },
  country: {
    fontSize: 12,
    color: "#A1A4AC",
    marginTop: 2,
    textAlign: "center",
  },
}));

export const SchoolStudentListItem: FC<ISchoolStudentListItemProps> = ({
  id,
  photo,
  status,
  name,
  hasNewMessage,
  country,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AvatarWithStatus
        status={status}
        hoverable
        src={photo}
        to={urlReplacer(`${Routes.STUDENT}/${Routes.APPLICATIONS}`, { id })}
        hasNewMessage={hasNewMessage}
        borderWidth={4}
      />
      <div className={classes.name}>{name}</div>
      <div className={classes.country}>{country}</div>
    </div>
  );
};
